var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6686 12.2861V15.1536H30.0685C30.1331 15.1528 30.1968 15.1549 30.2597 15.1601L22.6996 22.5897C22.6789 22.4577 22.6686 22.3243 22.6686 22.1906V15.1523H19.6293V22.1919C19.6293 25.1912 22.1287 27.6453 25.1292 27.6453H32.4594V24.7778H25.1292C25.1034 24.7778 25.078 24.7765 25.053 24.774L32.453 17.5032C32.4581 17.5738 32.4607 17.6452 32.4607 17.7176V24.7765H35.5V17.7176C35.5002 17.0043 35.3598 16.2979 35.0869 15.6388C34.814 14.9798 34.4139 14.381 33.9095 13.8766C33.4051 13.3722 32.8063 12.9721 32.1473 12.6992C31.4882 12.4263 30.7819 12.2859 30.0685 12.2861H22.6686ZM4.5 15.1497L15.195 27.1183C16.2787 28.3325 18.2898 27.5652 18.2898 25.9377V15.1497H15.0787V22.1764L8.80125 15.1497H4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV0);
export default __webpack_public_path__ + "static/media/v0.d14c7f20107621ab64ebe9c033d181b7.svg";
export { ForwardRef as ReactComponent };